import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const VENDORCONTACTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.VendorContactType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
];

export const VENDORCONTACTTYPE_CONFIG = {
  entityName: 'VendorContactType',
  localizationKey: 'Controlling::Entity.VendorContactType',
  fields: VENDORCONTACTTYPE_FIELDS,
  permission: 'ControllingContract.VendorContactTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
